import i18n from './i18nHelpers'

export default {
  getCompanyFullAddress (userCompany) {
    const currentLanguage = i18n.locale
    let address = userCompany.company_address
    const addressProvinceId = userCompany.address_province_id
    if (addressProvinceId) {
      const addressProvince = userCompany.address_province
      const district = userCompany.district
      const subDistrict = userCompany.sub_district
      const separator = (currentLanguage !== 'th') ? ', ' : ' '

      if (subDistrict) {
        const subDistrictName = (currentLanguage === 'th') ? subDistrict.name_th : subDistrict.name_en
        let subDistrictType = i18n.t('message.company_address.sub_district_type')
        if (addressProvinceId === 1) {
          subDistrictType = i18n.t('message.company_address.sub_district_bkk_type')
        }
        address += separator + subDistrictType + subDistrictName
      }

      if (district) {
        const districtName = (currentLanguage === 'th') ? district.name_th : district.name_en
        let districtType = i18n.t('message.company_address.district_type')
        if (addressProvinceId === 1) {
          districtType = i18n.t('message.company_address.district_bkk_type')
        }
        address += separator + districtType + districtName
      }

      if (addressProvince) {
        const provinceName = (currentLanguage === 'th') ? addressProvince.name_th : addressProvince.name_en
        let provinceType = i18n.t('message.company_address.province_type')
        address += separator + provinceType + provinceName
      }

      if (subDistrict) {
        address += separator + subDistrict.zip_code
      }
    }
    return address
  }
}



// WEBPACK FOOTER //
// ./src/helpers/addressHelpers.js